export default "__VITE_ASSET__EwW63BFQ__"